import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, FetchAPI, FormAPI, PanelAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AbortableCloseEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService, MessageService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { Endpoint } from '../../../constants/endpoints';
import { ApplicationRoute } from '../../../constants/routes';
import BaseController from '../../BaseController';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';

interface ReverseReasonType {
  descriptionNumber: string;
  reasonNumber: number;
}

@Controller({ component: 'layout-infusion-reverse-last-event', fragment: 'infusion-reverse-last-event' })
class InfusionReverseLastEvent extends BaseController {
  @Inject('form-reason')
  form!: FormAPI;

  @Inject('autocomplete-reason-list')
  autocompleteStep!: AutocompleteAPI;

  @Inject('fetch-reason')
  fetchSteps!: FetchAPI;

  @Inject('panel-loader')
  feedbackPanelLoader!: PanelAPI;

  @OnMount({target: 'layout-infusion-reverse-last-event'})
  onLayoutMount(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    this.context.set({ encounterId, patientId });
    InformationBarUtils.collapsedBar = true;
  }

  reverseLastEvent(reverseReasonType:ReverseReasonType ): void {
    this.feedbackPanelLoader.setVisible(true);

    const {
      encounterId,
      sequenceNumber,
      prescriptionNumber
    } = this.historyService.getCurrentRouteParams();

    const body = {
      encounterNumber: encounterId,
      prescriptionNumber: prescriptionNumber,
      reasonSequenceNumber: reverseReasonType.reasonNumber,
      solutionNumber: sequenceNumber,
    } as Record<string, Value>;

    HttpService.post(Endpoint.REVERSE_LAST_EVENT, {}, { body })
      .then(() => this.openSucessToast())
      .catch((error) => {
        const message = error.body.messageDescription;
        const errorMessage = error.body.errors.join('; ')

        if (message != null) {
          this.openErrorToast(message);
        } else {
          this.openErrorToast(errorMessage);
        }
      });
  }

  @OnBeforeCancel({ target: 'form-reason' })
  onFormCancel(event: AbortableCloseEvent): void {
    event.abort();
    applicationContext.popNavigationItem();
  }

  @OnBeforeSubmit({ target: 'form-reason' })
  onFieldClick(event: SubmitEvent): void {
    const reverseReasonType = event.record.reverseReasonType as ReverseReasonType;

    this.reverseLastEvent(reverseReasonType);
    this.form.setLocked(true);
  }

  handleReverseLastEventResponse = (): void => {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION, {
      encounterId,
      patientId,
    });
    applicationContext.clearNavigationStack();
  }

  openErrorToast(message: string): void {
    ToastService.open({
      dismissible: false,
      id: 'error-reverse-last-event',
      level: ToastLevel.WARNING,
      message: message,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
    this.handleReverseLastEventResponse();
  }

  openSucessToast(): void {
    ToastService.open({
      dismissible: true,
      id: 'sucess-reverse-last-event',
      level: ToastLevel.SUCCESS,
      message: MessageService.translate('text.revert-event'),
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
    this.handleReverseLastEventResponse();
  }
}

export default InfusionReverseLastEvent;
